import { inject, observer } from 'mobx-react';
import { ReactComponent as CloseIcon } from "../../svg/close.svg";
import React from 'react'
import ModalWrapper from '../Inputs/ModalWrapper';

@inject('workAreaStore', 'photoStore', 'sidebarStore', 'errorStore', 'saveStore', 'store') @observer

class Projects extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      name: ''
    }
  }

  async attachToBrand(projectId){
    const { workAreaStore } = this.props
    if(workAreaStore.pages.length === 1 && workAreaStore.pages[0].layers.length === 0){
      if(workAreaStore.saving){
        return
      }
      await this.props.saveStore.saveDesign(true, false, false, true)
    }
    const p = this.props.workAreaStore.brands.find(({ _id }) => _id === projectId)
    let name = ''
    if(p && p.name){
      name = '"' + p.name + '"'
    }
    this.props.errorStore.setErrorMessage(`Moved design under ${name} ${name.includes('brand') ? '' : 'brand'}`, false)
    this.props.workAreaStore.attachToBrand(projectId)
    this.props.photoStore.fetchUserImages(p, true)
  }

  handleChange(e){
    const { name, value } = e.target
    this.setState({[name]: value})
  }

  createProject(){
    this.props.workAreaStore.createNewBrand(this.state.name)
    this.props.errorStore.setErrorMessage('Created new brand: ' + this.state.name, false)
    this.setState({ name: '' })
  }

  close(){
    this.props.store.toggleAnyModal('projectsOpen', false)
  }

  redirectToBrandCreation(){
    const url = window.location.origin + '/dashboard/brands/create' + `?redirect=${window.location.href}`
    window.location.replace(url)
  }

  redirectToEditBrand(id){
    const url = window.location.origin + '/dashboard/brands/' + `${id}?redirect=${window.location.href}`
    window.location.replace(url)
  }

  render(){
    const { workAreaStore } = this.props
    const { brands, activeBrand } = workAreaStore
    return (
      <ModalWrapper
        close={() => this.close()}
        modalClass='projects-modal'
      >
        <div className='project-menu'>
          <div className='project-menu__header'>
            <span className='project-menu__header__title'>
              Move design under a brand
            </span>
            <span className='project-menu__header__link' onClick={e => this.redirectToBrandCreation()}>
              Create brand
            </span>
            <CloseIcon 
              className='project-menu__close'
              onClick={() => this.close()} 
            />
          </div>
          <div className='project-menu__body'>
            {
              false ? (
                <div className='project-menu__create'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='New project name'
                    name='name'
                    value={this.state.name}
                    onChange={e => this.handleChange(e)}
                  />
                  <button 
                    className='btn btn-danger'
                    onClick={() => this.createProject()}
                  >
                    New brand
                  </button>
                </div>
              )
              :
              undefined
            }
            {
              brands.length ? undefined : (
                <div className='project-menu__empty'>
                  <label className='primary'>No brands</label>
                  <span className='gray'>Start by creating one</span>
                </div>
              )
            }
            {
              brands.length ? 
              (
                <div className='project-menu__list'>
                  {
                    brands.map(p => {
                      const isActive = activeBrand && activeBrand._id === p._id
                      return (
                        <div 
                          key={p._id}
                          className={isActive ? 'project-menu__option attached' : 'project-menu__option'}
                          onClick={isActive ? undefined : () => this.attachToBrand(p._id)}
                        >
                          {
                            <div className='project-menu__meta'>
                              <span>
                                {p.name}
                              </span>
                              <button onClick={e => this.redirectToEditBrand(p._id)} className='btn-none edit-brand'>
                                Edit
                              </button>
                            </div>
                          }
                        </div>
                      )
                    })
                  }
                </div>
              )
              :
              undefined
            }
          </div>
        </div>
      </ModalWrapper>
    )
  }

}

export default Projects